// ── Starter templates for stokvel constitutions ──
// A new group can adopt one of these as version 1 of its constitution, then edit the
// clauses to match how it actually runs. Kept as plain text (one clause per block) so
// they drop straight into the editable constitution and export cleanly to PDF.

export const CONSTITUTION_TEMPLATES = [
  {
    id: "burial",
    label: "Burial society",
    text: `CONSTITUTION OF {GROUP} BURIAL SOCIETY

1. NAME
1.1 The society shall be known as {GROUP} ("the society").

2. OBJECTIVES
2.1 To assist members and their registered families with the costs of a funeral.
2.2 To promote mutual support among members in times of bereavement.

3. MEMBERSHIP
3.1 Membership is open to any person approved by the committee.
3.2 A member must register the family members covered by their membership.
3.3 The society may set a maximum number of people each member may cover.

4. CONTRIBUTIONS
4.1 Each member shall contribute the agreed amount on or before the due date.
4.2 A member whose contributions are in arrears is not in good standing.

5. WAITING PERIOD
5.1 A newly added member or covered person is subject to a waiting period, during which a claim does not qualify for the full payout.
5.2 The waiting period is set by the society and recorded in the platform.

6. CLAIMS AND PAYOUTS
6.1 On the death of a member or a registered covered person, the member may lodge a claim.
6.2 A claim is valid only if the member is in good standing and any waiting period has passed.
6.3 The society shall pay the agreed cover amount for that category of covered person.
6.4 A death certificate must be provided before a claim is paid.

7. GOVERNANCE
7.1 The society shall elect a chairperson, treasurer and secretary.
7.2 The treasurer keeps the records; the secretary keeps the minutes and this constitution.
7.3 Decisions are taken at meetings by majority vote.

8. MEETINGS
8.1 The society shall meet regularly; minutes shall be kept of every meeting.

9. AMENDMENTS
9.1 This constitution may be amended by a resolution passed at a meeting.
9.2 Every amendment is recorded with its version, and who made it and when.

10. DISSOLUTION
10.1 On dissolution, any remaining funds shall be distributed as the members resolve.`,
  },
  {
    id: "savings",
    label: "Savings / rotating (ROSCA)",
    text: `CONSTITUTION OF {GROUP}

1. NAME
1.1 The group shall be known as {GROUP} ("the group").

2. PURPOSE
2.1 To help members save together and each receive a lump sum in turn.

3. MEMBERSHIP
3.1 Membership is open to any person approved by the members.
3.2 Each member has one unique payment reference.

4. CONTRIBUTIONS
4.1 Each member contributes the agreed amount on or before the due date.
4.2 Contributions are paid into the group's own bank account.

5. PAYOUTS / ROTATION
5.1 Each cycle the pooled amount is paid out to one member, in an agreed order.
5.2 The rotation continues until every member has received once, then repeats.

6. LATE PAYMENTS
6.1 A member who pays late may be charged the agreed penalty after the grace period.

7. GOVERNANCE
7.1 The group elects a chairperson and a treasurer.
7.2 The treasurer keeps transparent records visible to all members.

8. MEETINGS
8.1 The group meets regularly; minutes are kept of every meeting.

9. AMENDMENTS
9.1 This constitution may be amended by majority resolution at a meeting.

10. DISSOLUTION
10.1 On dissolution, funds are shared according to what each member is owed.`,
  },
  {
    id: "grocery",
    label: "Grocery (year-end payout)",
    text: `CONSTITUTION OF {GROUP} GROCERY STOKVEL

1. NAME
1.1 The stokvel shall be known as {GROUP}.

2. PURPOSE
2.1 To save together through the year for a year-end payout in cash or groceries.

3. MEMBERSHIP
3.1 Membership is open to any person approved by the members.

4. CONTRIBUTIONS
4.1 Each member contributes the agreed amount monthly into the group account.
4.2 Each member's running total is recorded and visible to all.

5. PAYOUT
5.1 The pooled savings are paid out once, near year-end, as agreed.
5.2 Each member receives their share, plus any interest earned, less agreed costs.

6. LATE PAYMENTS
6.1 Late contributions may attract the agreed penalty after the grace period.

7. GOVERNANCE
7.1 The stokvel elects a chairperson and a treasurer who keeps the records.

8. MEETINGS
8.1 The stokvel meets regularly; minutes are kept.

9. AMENDMENTS
9.1 This constitution may be amended by majority resolution at a meeting.`,
  },
  {
    id: "general",
    label: "Family / general contribution",
    text: `CONSTITUTION OF {GROUP}

1. NAME
1.1 The group shall be known as {GROUP}.

2. PURPOSE
2.1 To pool funds for the family's or group's events, emergencies and mutual support.

3. MEMBERSHIP
3.1 Membership is open to persons approved by the members.

4. CONTRIBUTIONS
4.1 Members contribute the agreed amount, regularly or as called for.
4.2 All money is held in the group's own bank account.

5. USE OF FUNDS
5.1 Funds may be used for agreed purposes: events, emergencies, assistance to members.
5.2 The group may lend to members on terms it agrees, with repayment recorded.

6. GOVERNANCE
6.1 The group elects a chairperson and a treasurer who keeps transparent records.

7. MEETINGS
7.1 The group meets regularly; minutes are kept of every meeting.

8. AMENDMENTS
8.1 This constitution may be amended by majority resolution at a meeting.`,
  },
];

export function constitutionTemplate(id, groupName) {
  const t = CONSTITUTION_TEMPLATES.find((x) => x.id === id);
  if (!t) return "";
  return t.text.replace(/\{GROUP\}/g, (groupName || "the group").toUpperCase());
}
